import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { LocalStorage } from '../services/local-storage';
@Injectable()
export class AuthGuardRoute implements CanActivate {

    constructor(private router: Router, private localstorage : LocalStorage) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if (this.localstorage.getStorage('token')) {
            // logged in so return true
            console.log(this.localstorage.getStorage('selectedSegements'))
            return true;
        }
        // not logged in so redirect to login page with the return url
        this.router.navigate(['users/interest'], { queryParams: { returnUrl: state.url }});
        return false;
    }
}


// WEBPACK FOOTER //
// ./src/app/guards/auth.guard.route.component.ts